import { QueryFunction, useQuery, UseQueryResult } from '@tanstack/react-query';
import { CategoriesResponse } from '@twiliointernal/org/twilio/e2-commons/shared/definitions';

import { constants } from './definitions';
import { SupportApi } from '../../clients';
import logger from '../../../lib/logger';

export const getCategories: QueryFunction = async () => {
  try {
    const { data } = await SupportApi.getCategories();
    const categories = data?.categories ?? [];
    const products = categories.filter((category) => {
      const articles = category?.articles || [];

      // @todo - if needed, add filter condition for "product" category
      return articles.length > 0;
    });

    return { categories: products };
  } catch (error) {
    logger.error(`${constants.LOG_PREFIX}::${error}`);
  }
};

// @todo - refactor to make it more general with optional query keys (requires work on support-api as well)
const useFetchArticlesByProducts = (): UseQueryResult<CategoriesResponse> => {
  const queryKey = [constants.fetchArticlesByCategoriesFnKey];
  const queryFn = getCategories;

  return useQuery({
    queryKey,
    queryFn,
    staleTime: 600 * 1000, //10 minutes
  });
};

export default useFetchArticlesByProducts;
